/**
 * valid image
 * @param type
 * @returns
 */
export const validImage = (type: string): boolean => {
  const suffixList = ['bmp', 'jpg', 'jpeg', 'png', 'gif', 'pdf'];
  return suffixList.includes(type);
};

/**
 * valid msg
 */
export const validMsg = (msg: string): boolean => {
  return !!msg
    .replace(/<br\s*\/?>/gi, '')
    .replace(/&nbsp;/gi, '')
    .trim();
};
